import { LONG_DATE } from '../constants/dates';
import dateFormatter from './dateFormatter';

export default function longDateNoTime(
  date: Date | string,
  timeZone?: string
): string {
  return dateFormatter(date, LONG_DATE, timeZone);
}
